export default "__VITE_ASSET__D9p9Vt75__"